module.exports = __webpack_public_path__ + "static/img/13-北京钱学森中学.3918a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/13-北京钱学森中学.png
// module id = Lm0M
// module chunks = 0